<template>
  <div>{{ time }}</div>
</template>

<script>
let interval = null;
let startSeconds = Math.floor(Math.random() * 59) + 1;

export default {
  name: "TimerSimple",

  props: {
    mins: {
      default: 13
    }
  },

  data() {
    return {
      time: ("0" + this.mins).slice(-2) + ":" + ("0" + startSeconds).slice(-2),
      finishTime: null
    };
  },

  methods: {
    changeTimeByDifference() {
      let diff = this.finishTime.getTime() - new Date().getTime();
      diff = Math.floor(diff / 1000);

      const minutes = Math.floor(diff / 60) % 60;
      const seconds = diff % 60;

      this.time = [minutes, seconds].map(numbers => ("0" + numbers).slice(-2)).join(":");

      if (this.time === "00:00") {
        clearInterval(interval);
      }
    },
    
    reset() {
      this.finishTime = new Date(new Date().getTime() + this.mins * 60 * 1000 + (startSeconds + 1) * 1000);
    }
  },

  mounted() {
    this.reset();
    interval = setInterval(this.changeTimeByDifference, 1000);
  }
};
</script>

<style lang="scss"></style>
